module.exports = __webpack_public_path__ + "static/media/Muli-SemiBold.d3db23a8.ttf";